<template>
  <div>
    <header id="header">
      <div class="inner">
        <h1 class="logo"><a href="/" title="to home"><img :src="require(`../resource/images/logo${this.sub}.png`)" alt="애드매스"></a></h1>
        <nav id="gnb" class="total-menu">
          <h2 class="blind">Menu</h2>
          <ul class="area">
            <li class="gnb1">
              <a href="#"><span>COMPANY</span></a>
              <div class="gnb-2dep">
                <ul>
                  <li><a href="/intro"><span>회사 소개</span></a></li>
                  <li><a href="/history"><span>회사 연혁</span></a></li>
                </ul>
              </div>
            </li>
            <li class="gnb2">
              <a href="#"><span>SERVICE</span></a>
              <div class="gnb-2dep">
                <ul>
                  <li><a href="/service/hometown"><span>SKB 우리동네광고</span></a></li>
                  <li><a href="/service/skylife"><span>KT스카이라이프 IPTV광고</span></a></li>
                  <li><a href="/service/experience"><span>체험단 마케팅</span></a></li>
                  <li><a href="/service/reporter"><span>기자단 마케팅</span></a></li>
                  <li><a href="/service/insta"><span>인스타 마케팅</span></a></li>
                  <li><a href="/service/viral"><span>바이럴 마케팅</span></a></li>
                </ul>
              </div>
            </li>
            <li class="gnb3">
              <a href="/portpolio"><span>PORTFOLIO<span></span></span></a>
            </li>
            <li class="gnb4">
              <a href="/notice"><span>NOTICE<span></span></span></a>
            </li>
            <li class="gnb5">
              <a href="#"><span>CONTACT<span></span></span></a>
              <div class="gnb-2dep">
                <ul>
                  <li><a href="contact-us"><span>상담 신청</span></a></li>
                  <li><a href="map"><span>오시는 길</span></a></li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
        <button type="button" class="btn-menu"><img :src="require(`../resource/images/ico_menu${this.sub}.png`)" alt="사이트맵 보기"></button>
        <!-- 사이트맵 -->
        <div class="sitemap-wrap">
          <div class="inner">
            <h2 class="title">SITEMAP</h2>
            <div class="total-menu">
              <ul class="area">
                <li class="gnb1">
                  <a href="#"><span>COMPANY</span></a>
                  <div class="gnb-2dep">
                    <ul>
                      <li><a href="/intro"><span>회사 소개</span></a></li>
                      <li><a href="/history"><span>회사 연혁</span></a></li>
                    </ul>
                  </div>
                </li>
                <li class="gnb2">
                  <a href="#"><span>SERVICE</span></a>
                  <div class="gnb-2dep">
                    <ul>
                      <li><a href="/service/hometown"><span>SKB 우리동네광고</span></a></li>
                      <li><a href="/service/skylife"><span>KT스카이라이프 IPTV광고</span></a></li>
                      <li><a href="/service/experience"><span>체험단 마케팅</span></a></li>
                      <li><a href="/service/reporter"><span>기자단 마케팅</span></a></li>
                      <li><a href="/service/insta"><span>인스타 마케팅</span></a></li>
                      <li><a href="/service/viral"><span>바이럴 마케팅</span></a></li>
                    </ul>
                  </div>
                </li>
                <li class="gnb3">
                  <a href="/portpolio"><span>PORTFOLIO<span></span></span></a>
                </li>
                <li class="gnb4">
                  <a href="/notice"><span>NOTICE<span></span></span></a>
                </li>
                <li class="gnb5">
                  <a href=#><span>CONTACT<span></span></span></a>
                  <div class="gnb-2dep">
                    <ul>
                      <li><a href="/contact-us"><span>상담 신청</span></a></li>
                      <li><a href="/map"><span>오시는 길</span></a></li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <button type="button" class="btn-close"><img src="../resource/images/ico_menu.png" alt="사이트맵 닫기"></button>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'common-header',
  components: {

  },
  data() {
    return {
      sub: ''
    }
  },
  mounted() {
    this.sub = location.pathname !== '/' ? '_sub' : '';

    const gnbLi = document.querySelectorAll('#gnb > ul > li');

    for(let i = 0; i < gnbLi.length; i++){
      gnbLi[i].addEventListener('mouseover', function() {
        if(gnbLi[i].querySelector(".gnb-2dep"))
        gnbLi[i].querySelector(".gnb-2dep").classList.add('active');
        //subMenu[i].classList.add('active');
      });
    }

    for(let i = 0; i < gnbLi.length; i++){
      gnbLi[i].addEventListener('mouseleave', function() {
        if(gnbLi[i].querySelector(".gnb-2dep"))
        gnbLi[i].querySelector(".gnb-2dep").classList.remove('active')
      });
    }


    const btnMenu = document.querySelector('.btn-menu');
    const siteMapWrap = document.querySelector('.sitemap-wrap');
    const siteMapClose = siteMapWrap.querySelector(".btn-close")

    btnMenu.addEventListener('click', function() {
      siteMapWrap.classList.add('active');
    })
    siteMapClose.addEventListener('click', function() {
      siteMapWrap.classList.remove('active');
    })/* Line 2 */

  }
}
</script>

<style>

</style>